import http from './api'

const route = 'app/precomedio/'

export default {
  showDadosComparativoPrecoMedio: (dataInicial, dataFinal, empresaSelect, cidades, produtos, areas, vendedores, redes, caixas, dataInicial2, dataFinal2, empresaSelect2, cidades2, produtos2, areas2, vendedores2, redes2, caixas2, tokencontrato, segmento, segmento1) => {
    return http.post(route + 'showDadosComparativoPrecoMedio', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      cidades: cidades,
      produtos: produtos,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      caixas: caixas,
      dataInicial2: dataInicial2,
      dataFinal2: dataFinal2,
      empresas2: empresaSelect2,
      cidades2: cidades2,
      produtos2: produtos2,
      areas2: areas2,
      vendedores2: vendedores2,
      redes2: redes2,
      caixas2: caixas2,
      tokenContrato: tokencontrato,
      segmento: segmento,
      segmento1: segmento1,
    })
  },
}
